import { useEffect, useState } from 'react'

/**
 * Tracks a CSS media query. Reads `window.matchMedia` in the initializer so the first
 * paint already knows whether we are on a phone — this SPA has no SSR, so `window` is
 * always there.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches)

  useEffect(() => {
    const mq = window.matchMedia(query)
    const onChange = () => setMatches(mq.matches)
    onChange()
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [query])

  return matches
}

/**
 * Compact chrome (drawer, bottom sheets). Matches Tailwind `lg` (1024px) so iPhone
 * landscape and iPad portrait get the same layout the CSS uses — `md` (768) is too
 * narrow and served the desktop rails on a phone turned sideways.
 */
export const useIsPhone = () => useMediaQuery('(max-width: 1023px)')
